import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { UserRegistrationService } from 'src/app/service/userresgistration.service';
import { Router } from '@angular/router';
import {
  RegistrationExport,
  SsoRegistrationRequest,
  RegistrationSource,
} from '../../shared/models/registration';
import { RegistrationSecurityquestionsComponent } from '../registration-securityquestions/registration-securityquestions.component';
import { ToastPopUpComponents } from 'src/app/shared/services/toast-popup.service';
import { DatePipe, formatDate } from '@angular/common';
import { UserService } from 'src/app/service/user.service';
import { UtilityService } from './../../shared/services/utility.service';
import { VoeService } from './../../shared/services/voe.service';
import { SsoRegistration } from 'src/app/shared/models/ssorequest';
import { LoginResponse } from 'src/app/shared/models/loginrequest';

import {
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastOptions } from 'src/app/core/components/toast/toast.component';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';
import { SentenceCasePipe } from 'src/app/shared/pipes/sentence-case.pipe';
import { DateAdapter } from '@angular/material/core';

declare var $: any;

@Component({
  selector: 'app-registration',
  providers: [SentenceCasePipe],
  template: `
    <!-- Loading indicator while translations are loading -->
    <div *ngIf="!translationsReady" class="tw-flex tw-justify-center tw-items-center tw-min-h-[200px]">
    </div> 
    
    <!-- Main content - only show when translations are ready -->
    <div *ngIf="translationsReady">
      <div
        *ngIf="onHaveClaimNumberStep"
        id="checkClaimNumber"
        class="app-ml3 app-mr3 app-mt2"
        role="none"
      >
      <h1 role="heading" [attr.aria-label]="'Registration' | translation : translationRequest">{{'Registration' | translation : translationRequest}}</h1>

      <!-- form begin -->
      <div class="registration-container">
        <form role="none" [formGroup]="regClaimNumberForm">
          <ul class="" role="none">
            <span class="tw-w-full tw-font-bold">
              {{'Forms with * are required to be filled out.' | translation}} 
            </span>
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center"
            >
              <label class="tw-w-full md:tw-w-[50%]" id="haveClaimNumber"
                >{{'Do you have a claim number?' | translation}} *</label
              >
              <div class="tw-w-full md:tw-w-[50%] tw-items-start">
                <mat-radio-group
                  formControlName="haveClaimNumber"
                  [attr.aria-label]="'Do you have a claim number? (required)' | translation : translationRequest"
                  [(ngModel)]="haveClaimNumberModel"
                >
                  <mat-radio-button
                    labelPosition="before"
                    tabindex="0"
                    [attr.aria-label]="'Yes' | translation : translationRequest"
                    value="YES"
                    (change)="handleChange('YES')"
                    class="app-ml2 app-mr2"
                    >{{'Yes' | translation}}
                  </mat-radio-button>
                  <mat-radio-button
                    labelPosition="before"
                    tabindex="0"
                    [attr.aria-label]="'No' | translation : translationRequest"
                    value="NO"
                    (change)="handleChange('NO')"
                    >{{'No' | translation : translationRequest}}</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </li>
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center app-mt3"
              *ngIf="haveClaimNumberModel == 'YES'"
            >
              <label for="claimNumber" class="tw-w-full md:tw-w-[50%]"
                >{{'Claim Number' | translation : translationRequest | sentenceCase}} *</label
              >
              
              <mat-form-field
                role="none"
                tabindex="-1"
                class="tw-w-full md:tw-w-[50%]"
              >
                <input
                  type="text"
                  class="tw-w-full md:tw-w-[50%]"
                  formControlName="claimNumber"
                  matInput
                  name="claimNumber"
                  id="claimNumber"
                  autocomplete="off"
                  maxlength="50"
                  class="input"
                  [attr.aria-label]="'Claim number' | translation : translationRequest | sentenceCase"
                />
              </mat-form-field>
            </li>
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mt3 tw-justify-end app-mb3"
            >
              <div class="tw-flex tw-flex-row  app-mt3">
                <app-button
                  emphasis="Low"
                  mat-raised-button
                  (click)="onCancel()"
                  class="app-pr2"
                >
                  {{'Cancel' | translation : translationRequest}}
                </app-button>
                <app-button
                  type="submit"
                  [disabled]="
                    !regClaimNumberForm.valid && haveClaimNumberModel != 'NO'
                  "
                  (click)="moveToRegistration()"
                  emphasis="High"
                  mat-raised-button
                >
                  {{'Next' | translation : translationRequest}}
                </app-button>
              </div>
            </li>

            <ng-container
              *ngIf="
                haveClaimNumberModel != 'NO' && personalInfoErrorMessage != ''
              "
            >
              <p class="app-mt2">
                <app-toast
                  [message]="personalInfoErrorMessage"
                  [type]="toastEnumOptions.Error"
                ></app-toast>
              </p>
            </ng-container>
          </ul>
        </form>
      </div>
      <!-- form end -->
    </div>
    <!-- Check Claim Number END -->
    <!-- Registration begin -->
    <div
      *ngIf="onStartRegistration"
      id="startRegistration"
      class="app-ml3 app-mr3 app-mt2"
      role="none"
    >
      <h1 role="heading" [attr.aria-label]="'Registration' | translation : translationRequest">{{'Registration' | translation : translationRequest}}</h1>

      <!-- form begin -->
      <div class="registration-container">
        <form [formGroup]="registrationForm" role="none">
          <div
            *ngIf="
              registrationProcessErrorMessage != '' &&
              registrationProcessErrorMessage != 'Success'
            "
            class="app-mt2"
          >
            <app-toast
              [message]="registrationProcessErrorMessage"
              [type]="toastEnumOptions.Error"
            ></app-toast>
            <div
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mt3 tw-justify-end "
            >
              <app-button
              type="button"
              class="button"
              mat-raised-button
              (click)="onCancel()"
              enphasis="Low"
              mat-raised-button
            >
              {{'Cancel' | translation}}
            </app-button>
            </div>
          </div>

          <ul
            role="none"
            class="tw-flex tw-flex-wrap"
            *ngIf="registrationProcessErrorMessage == 'Success'"
            role="none"
          >
            <span class="tw-w-full tw-font-bold">
            {{'Forms with * are required to be filled out.' | translation : translationRequest}}  
            </span>
            <li
              role="none"
              *ngIf="showLastName == true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="lastName"
                >{{'Last name' | translation : translationRequest | sentenceCase}}: *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%]"
              >
                <input
                  matInput
                  class="input"
                  formControlName="lastName"
                  name="lastName"
                  required
                  id="lastName"
                  autocomplete="off"
                  [attr.aria-label]="'Last name' | translation : translationRequest | sentenceCase"
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('lastName').invalid &&
                    registrationForm.get('lastName').errors &&
                    (registrationForm.get('lastName').dirty ||
                      registrationForm.get('lastName').touched) &&
                    registrationForm.get('lastName').hasError('required')
                  "
                >
                  <span>{{'Error : Last name is required.' | translation : translationRequest | sentenceCase}} </span>
                </mat-error>
                <mat-error
                  role="none"
                  *ngIf="
                    registrationForm.get('lastName').invalid &&
                    registrationForm.get('lastName').errors &&
                    (registrationForm.get('lastName').dirty ||
                      registrationForm.get('lastName').touched) &&
                    registrationForm.get('lastName').hasError('pattern')
                  "
                >
                  <span>{{'Error : Please enter a valid last name.' | translation : translationRequest | sentenceCase}}  </span>
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="showDOB == true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="dateofBirth"
                >{{'Date of birth' | translation : translationRequest | sentenceCase}} *</label
              >
              <mat-form-field
                id="birthDate"
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] custom-datepicker"
              >
                <input
                  matInput
                  [matDatepicker]="dob"
                  [max]="maxDate"
                  required
                  [attr.aria-label]="'Enter Date of birth or select from calendar popup' | translation : translationRequest | sentenceCase"
                  formControlName="dateofBirth"
                  autocomplete="off"
                />
                <mat-datepicker-toggle class="" matSuffix [for]="dob">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #dob
                  [dateClass]="setClass"
                  (opened)="toggleDatepicker()"
                  [startAt]="null"
                >
                </mat-datepicker>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('dateofBirth').hasError('required')
                  "
                >
                  <span>{{'Error : Please enter a valid date of birth.' | translation : translationRequest | sentenceCase}}</span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message mat-error-disable"
                  *ngIf="
                    registrationForm
                      .get('dateofBirth')
                      .hasError('matDatepickerMax')
                  "
                >
                  <span>{{'Error : Date of birth cannot be greater than today.' | translation : translationRequest | sentenceCase}}
                    </span
                  >
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="showSSN == true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="last4SSN"
                >{{'Last 4 digits of SSN' | translation : translationRequest}} *
                </label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  matInput
                  [maxlength]="4"
                  type="password"
                  formControlName="last4SSN"
                  name="last4SSN"
                  id="last4SSN"
                  autocomplete="off"
                  [attr.aria-label]="'Enter Last 4 digits of SSN' | translation : translationRequest | sentenceCase"
                />

                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('last4SSN').invalid &&
                      registrationForm.get('last4SSN').errors) ||
                      registrationForm.get('last4SSN').dirty ||
                      registrationForm.get('last4SSN').touched) &&
                    registrationForm.get('last4SSN').hasError('required')
                  "
                >
                  <span>
                  {{'Error : Last 4 digits of SSN is required.' | translation : translationRequest | sentenceCase}}  
                  </span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('last4SSN').invalid &&
                      registrationForm.get('last4SSN').errors) ||
                      registrationForm.get('last4SSN').dirty ||
                      registrationForm.get('last4SSN').touched) &&
                    registrationForm.get('last4SSN').hasError('minlength')
                  "
                >
                  <span>
                     {{'Error : Please enter at least' | translation : translationRequest }}  
                    
                    {{
                      registrationForm.get('last4SSN').errors['minlength']
                        .requiredLength
                    }}
                     {{'characters.' | translation : translationRequest }}  
                    
                  </span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('last4SSN').invalid &&
                      registrationForm.get('last4SSN').errors) ||
                      registrationForm.get('last4SSN').dirty ||
                      registrationForm.get('last4SSN').touched) &&
                    registrationForm.get('last4SSN').hasError('maxlength')
                  "
                >
                  <span>
                    {{'Error : The maximum length for this field is' | translation : translationRequest }}                     
                    
                    {{
                      registrationForm.get('last4SSN').errors['maxlength']
                        .requiredLength
                    }}
                    {{'characters.' | translation : translationRequest }}
                    
                  </span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('last4SSN').invalid &&
                      registrationForm.get('last4SSN').errors) ||
                      registrationForm.get('last4SSN').dirty ||
                      registrationForm.get('last4SSN').touched) &&
                    registrationForm.get('last4SSN').hasError('pattern')
                  "
                >
                  <span> 
                   {{'Error : Please enter numbers for this field.' | translation : translationRequest | sentenceCase}}
                      
                  </span>
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="isLiabilityClaim === true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="claimCity"
                >
                {{'City' | translation : translationRequest}} *                    
                </label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  matInput
                  formControlName="claimCity"
                  name="claimCity"
                  id="claimCity"
                  [attr.aria-label]="'City' | translation : translationRequest"
                  autocomplete="off"
                  required
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="registrationForm.get('claimCity').hasError('required')"
                >
                  <span>
                  {{'Error : City is required.' | translation : translationRequest}}    
                  </span>
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="isLiabilityClaim === true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="claimState"
                >{{'State' | translation : translationRequest}} *  
                </label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  matInput
                  formControlName="claimState"
                  name="claimState"
                  id="claimState"
                  [attr.aria-label]="'State' | translation : translationRequest"
                  autocomplete="off"
                  required
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('claimState').hasError('required')
                  "
                >
                  <span> {{'Error : State is required.' | translation : translationRequest}} </span>
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="showZipCode === true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="zipCode"
                >{{labelZipCode | translation : translationRequest | sentenceCase}} *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  matInput
                  formControlName="zipCode"
                  [maxLength]="maxZipcodeLength"
                  required
                  name="zipCode"
                  id="zipCode"
                  autocomplete="off"
                  [attr.aria-label]="'Home postal code' | translation : translationRequest | sentenceCase"
                  [attr.title]="'Please do not enter dashes or spaces for postal code.' | translation : translationRequest"
                />

                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('zipCode').invalid &&
                      registrationForm.get('zipCode').errors) ||
                      registrationForm.get('zipCode').dirty ||
                      registrationForm.get('zipCode').touched) &&
                    registrationForm.get('zipCode').hasError('required')
                  "
                >
                  <span> {{ errorZipCode | translation : translationRequest | sentenceCase}}</span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('zipCode').invalid &&
                      registrationForm.get('zipCode').errors) ||
                      registrationForm.get('zipCode').dirty ||
                      registrationForm.get('zipCode').touched) &&
                    registrationForm.get('zipCode').hasError('minlength')
                  "
                >
                  <span>
                    {{'Error : Please enter at least' | translation : translationRequest}}
                    {{
                      registrationForm.get('zipCode').errors['minlength']
                        .requiredLength
                    }}
                    {{'characters.' | translation : translationRequest}}                    
                  </span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('zipCode').invalid &&
                      registrationForm.get('zipCode').errors) ||
                      registrationForm.get('zipCode').dirty ||
                      registrationForm.get('zipCode').touched) &&
                    registrationForm.get('zipCode').hasError('maxlength')
                  "
                >
                  <span>
                    {{'Error : The maximum length for this field is' | translation : translationRequest}}  
                    
                    {{
                      registrationForm.get('zipCode').errors['maxlength']
                        .requiredLength
                    }}
                    {{'characters.' | translation : translationRequest}}                     
                    
                  </span>
                </mat-error>

                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('zipCode').invalid &&
                      registrationForm.get('zipCode').errors) ||
                      registrationForm.get('zipCode').dirty ||
                      registrationForm.get('zipCode').touched) &&
                    registrationForm
                      .get('zipCode')
                      .hasError('inValidZopcodeCanada')
                  "
                >
                  <span>
                    {{"Error : Please enter a valid Canadian postal code in ‘A9A9A9’ format." | translation : translationRequest | sentenceCase}}                    
                    
                    </span
                  >
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    ((registrationForm.get('zipCode').invalid &&
                      registrationForm.get('zipCode').errors) ||
                      registrationForm.get('zipCode').dirty ||
                      registrationForm.get('zipCode').touched) &&
                    registrationForm.get('zipCode').hasError('inValidZopcodeUS')
                  "
                >
                  <span>
                    {{"Error : Please enter a valid US zip code in ‘99999’ format." | translation : translationRequest | sentenceCase}}                   
                    
                    </span
                  >
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="showZipCode === true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]"
                ><span class="hidden" aria-hidden="true"></span
              ></label>
              <span class="tw-w-full tw-font-bold md:tw-w-[50%]">
                {{'Please do not enter dashes or spaces for postal code.' | translation : translationRequest | sentenceCase}}                   
                    
                
              </span>
            </li>

            <li
              role="none"
              *ngIf="showEmployeeId === true"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-center app-mt2 app-mb2 "
            >
              <label class="tw-w-full md:tw-w-[50%]" for="employeeId"
                >{{ labelEmployeeID | translation : translationRequest }} *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  required
                  matInput
                  formControlName="employeeId"
                  name="employeeId"
                  id="employeeId"
                  [attr.aria-label]="labelEmployeeID | translation : translationRequest"
                  autocomplete="off"
                  maxlength="256"
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('employeeId').hasError('required')
                  "
                >
                  <span> {{'Error :' | translation : translationRequest}}{{ labelEmployeeID | translation : translationRequest }} {{'is required.' | translation : translationRequest}}</span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="registrationForm.get('employeeId').hasError('pattern')"
                >
                  <span>
                   {{'Error : Please enter a valid' | translation : translationRequest}} {{ labelEmployeeID | translation : translationRequest }} .</span
                  >
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('employeeId').hasError('maxLength')
                  "
                >
                  <span>
                    
                    {{'Error : ' | translation : translationRequest}} {{ labelEmployeeID | translation : translationRequest }} {{'cannot be greater than 256 characters.' | translation : translationRequest}} </span
                  >
                </mat-error>
              </mat-form-field>
            </li>

            <div
              *ngIf="!requireClaimNumber && !requireEmpId"
              class="tw-w-full tw-flex tw-justify-end app-mt2"
            >
              <app-button
                type="button"
                emphasis="Low"
                mat-raised-button
                (click)="onCancel()"
                class="app-pr2"
              >
                {{'Cancel' | translation : translationRequest}}
              </app-button>

              <app-button
                type="submit"
                [disabled]="!registrationForm.valid"
                (click)="moveToUserNameSelection()"
                emphasis="High"
                mat-raised-button
              >
                 {{'Next' | translation : translationRequest}}
              </app-button>
            </div>

            <p class="app-mt2">
              <app-toast
                *ngIf="personalInfoErrorMessage !== ''"
                [message]="personalInfoErrorMessage"
                isToastFocus="true"
                [type]="toastEnumOptions.Error"
              ></app-toast>
            </p>

            <li
              role="none"
              *ngIf="requireClaimNumber"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="claimNumberForReg"
                > {{'Claim number' | translation : translationRequest}} *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  matInput
                  formControlName="claimNumberForReg"
                  name="claimNumberForReg"
                  [attr.aria-label]="'Claim number' | translation : translationRequest"
                  required
                  id="claimNumberForReg"
                  autocomplete="off"
                  maxlength="50"
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm
                      .get('claimNumberForReg')
                      .hasError('required')
                  "
                >
                  <span>{{'Error : Claim number is required.' | translation : translationRequest | sentenceCase}} </span>
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              *ngIf="requireEmpId"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="employeeId"
                >{{ labelEmployeeID | translation : translationRequest | sentenceCase }} *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
                <input
                  class="form-control"
                  matInput
                  formControlName="employeeId"
                  name="employeeId"
                  id="employeeId"
                  autocomplete="off"
                  required
                  [attr.aria-label]="labelEmployeeID | translation : translationRequest | sentenceCase"
                  maxlength="256"
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('employeeId').hasError('required')
                  "
                >
                  <span> {{'Error :' | translation : translationRequest | sentenceCase}} {{ labelEmployeeID | translation : translationRequest | sentenceCase }} {{'is required.' | translation : translationRequest | sentenceCase}} </span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="registrationForm.get('employeeId').hasError('pattern')"
                >
                  <span>{{'Error : Please enter a valid' | translation : translationRequest}}
                    {{ labelEmployeeID | sentenceCase }}.</span
                  >
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    registrationForm.get('employeeId').hasError('maxLength')
                  "
                >
                  <span>
                    {{'Error :' | translation : translationRequest | sentenceCase }}{{ labelEmployeeID | translation : translationRequest | sentenceCase }}  {{'cannot be greater than 256 characters.' | translation : translationRequest | sentenceCase }} </span
                  >
                </mat-error>
              </mat-form-field>
            </li>
          </ul>

          <div
            *ngIf="requireClaimNumber || requireEmpId"
            class="tw-w-full tw-flex tw-justify-end app-mt2"
          >
            <app-button
              type="button"
              mat-raised-button
              (click)="onCancel()"
              emphasis="Low"
              class="app-pr2"
            >
               {{'Cancel' | translation : translationRequest }}
            </app-button>

            <app-button
              type="submit"
              [disabled]="!registrationForm.valid"
              (click)="moveToUserNameSelection()"
              class="button"
              mat-raised-button
              emphasis="High"
            >
             {{'Next' | translation : translationRequest }}
              
            </app-button>
          </div>
        </form>
      </div>
    </div>
    <!-- Registration END -->
    <!-- Choose User name begin -->
    <div
      *ngIf="onSelectUsername"
      id="chooseUsername"
      class="app-ml3 app-mr3 app-mt2 "
    >
      <div class="tw-w-full md:tw-w-[50%]">
        <h1 role="heading">
          {{'Choose User name/password' | translation : translationRequest | sentenceCase}}
              
         </h1>
        <app-pwinstructions></app-pwinstructions>
        <div class="app-pt1">
          <strong>
          {{'*Required' | translation : translationRequest }}
             
          </strong>
        </div>
        <!-- form begin -->
        <div class="registration-container" [hidden]="!onSelectUsername">
          <div class="">
            <form
              role="none"
              [formGroup]="registrationUserNameForm"
              autocomplete="off"
            >
              <ul role="none" class="tw-flex tw-flex-wrap">
                <li
                  role="none"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-center app-mt2"
                >
                  <label class="tw-w-full md:tw-w-[50%]" for="userName"
                    >{{'User name' | translation : translationRequest | sentenceCase}}: *
             </label
                  >
                  <mat-form-field
                    [@.disabled]="animationsDisabled"
                    class="tw-w-full md:tw-w-[50%] "
                  >
                    <input
                      class="form-control"
                      matInput
                      formControlName="userName"
                      required
                      name="userName"
                      id="userName"
                      autocomplete="off"
                      [attr.aria-label]="'User name' | translation : translationRequest | sentenceCase"
                    />
                    <mat-error
                      role="none"
                      class="error-message"
                      *ngIf="
                        registrationUserNameForm.get('userName').invalid &&
                        registrationUserNameForm.get('userName').errors &&
                        (registrationUserNameForm.get('userName').dirty ||
                          registrationUserNameForm.get('userName').touched) &&
                        registrationUserNameForm
                          .get('userName')
                          .hasError('required')
                      "
                    >
                      <span> {{'Error : User name is required.' | translation : translationRequest | sentenceCase}}  </span>
                    </mat-error>
                    <mat-error
                      role="none"
                      class="error-message"
                      *ngIf="
                        registrationUserNameForm.get('userName').invalid &&
                        registrationUserNameForm.get('userName').errors &&
                        (registrationUserNameForm.get('userName').dirty ||
                          registrationUserNameForm.get('userName').touched) &&
                        registrationUserNameForm
                          .get('userName')
                          .hasError('minlength')
                      "
                    >
                      <span>
                        {{'Error : Please enter at least' | translation : translationRequest | sentenceCase}} 
                        
                        {{
                          registrationUserNameForm.get('userName').errors[
                            'minlength'
                          ].requiredLength
                        }}
                         {{'characters.' | translation : translationRequest | sentenceCase}} 
                       
                        
                      </span>
                    </mat-error>
                    <mat-error
                      role="none"
                      class="error-message"
                      *ngIf="
                        registrationUserNameForm.get('userName').invalid &&
                        registrationUserNameForm.get('userName').errors &&
                        (registrationUserNameForm.get('userName').dirty ||
                          registrationUserNameForm.get('userName').touched) &&
                        registrationUserNameForm
                          .get('userName')
                          .hasError('maxlength')
                      "
                    >
                      <span>
                        {{'Error : Please enter no more than' | translation : translationRequest | sentenceCase}} 
                        {{
                          registrationUserNameForm.get('userName').errors[
                            'maxlength'
                          ].requiredLength
                        }}
                         {{'characters.' | translation : translationRequest | sentenceCase}} 
                       
                        
                      </span>
                    </mat-error>
                    <mat-error
                      class="error-message"
                      *ngIf="
                        registrationUserNameForm.get('userName').invalid &&
                        registrationUserNameForm.get('userName').errors &&
                        (registrationUserNameForm.get('userName').dirty ||
                          registrationUserNameForm.get('userName').touched) &&
                        registrationUserNameForm
                          .get('userName')
                          .hasError('pattern')
                      "
                    >
                      <span> {{'Error : Please a valid user name.' | translation : translationRequest | sentenceCase}} 
                        </span>
                    </mat-error>
                  </mat-form-field>
                </li>

                <app-password
                  [showPassword]="!hidePw"
                  [parentForm]="registrationUserNameForm"
                  [parentFormGroupName]="'passwordGroup'"
                  [showEyeIcon]="true"
                  formGroupName="passwordGroup"
                  class="app-mb2"
                >
                </app-password>
                <mat-divider class="mat-divider"></mat-divider>
                <div class="app-mb1 app-mt1 tw-w-full">
                  <label
                    >
                    {{'Please provide your personal information for your user profile.' | translation : translationRequest | sentenceCase}} 
                        
                    </label
                  >
                </div>

                <li
                  role="none"
                  *ngIf="!isLiabilityClaim"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-center app-mt2 app-mb2"
                >
                  <label for="personalEmail" class="tw-w-full md:tw-w-[50%]"
                    >
                    {{'Email' | translation : translationRequest | sentenceCase}}: *                     
                    </label
                  >
                  <mat-form-field class="tw-w-full md:tw-w-[50%]">
                    <input
                      matInput
                      class="input"
                      type="email"
                      formControlName="personalEmail"
                      name="personalEmail"
                      required
                      id="personalEmail"
                      autocomplete="off"
                      [attr.aria-label]="'Personal email' | translation : translationRequest | sentenceCase"
                    />
                    <mat-error
                      role="none"
                      class="error-message"
                      *ngIf="
                        registrationUserNameForm.get('personalEmail').invalid &&
                        registrationUserNameForm.get('personalEmail').errors &&
                        (registrationUserNameForm.get('personalEmail').dirty ||
                          registrationUserNameForm.get('personalEmail')
                            .touched) &&
                        registrationUserNameForm
                          .get('personalEmail')
                          .hasError('required')
                      "
                    >
                      <span>
                      {{'Error : Personal email is required.' | translation : translationRequest | sentenceCase}}        
                      </span>
                    </mat-error>
                    <mat-error
                      role="none"
                      class="error-message"
                      *ngIf="
                        registrationUserNameForm.get('personalEmail').invalid &&
                        registrationUserNameForm.get('personalEmail').errors &&
                        (registrationUserNameForm.get('personalEmail').dirty ||
                          registrationUserNameForm.get('personalEmail')
                            .touched) &&
                        registrationUserNameForm
                          .get('personalEmail')
                          .hasError('pattern')
                      "
                    >
                      <span>  {{'Error : Please enter a valid email.' | translation : translationRequest | sentenceCase}}  </span>
                    </mat-error>
                  </mat-form-field>
                </li>

                <li
                  role="none"
                  *ngIf="isLiabilityClaim == false"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-items-center app-mt2"
                >
                  <label for="mobileNumber" class="tw-w-full md:tw-w-[50%]"
                    >{{'Cell phone number :' | translation : translationRequest | sentenceCase}} </label
                  >
                  <div class="tw-w-full md:tw-w-[50%]">
                    <app-phone
                      [required]="false"
                      [phoneLabel]="'Cell Phone'"
                      [parentForm]="registrationUserNameForm"
                      [parentFormGroupName]="'mobileNumber'"
                      [@.disabled]="animationsDisabled"
                      formControlName="mobileNumber"
                      name="mobileNumber"
                    ></app-phone>
                  </div>
                </li>
                <mat-divider class="mat-divider"></mat-divider>
                 <li
                 *ngIf="showMultilanguage"
              role="none"              
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row  tw-items-center app-mt2 app-mb2"
            >
              <label class="tw-w-full md:tw-w-[50%]" for="preferredLanguage"
                >{{'Preferred Language :' | translation : translationRequest}} *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%] "
              >
               <mat-select
                  autocomplete="off"
                  required
                  id="preferredLanguage"
                  formControlName="preferredLanguage"
                  [placeholder]="'Select One' | translation"
                  [attr.aria-label]="'Preferred Language' | translation"
                  class="tw-bg-[var(--sed-open-grey-color)]"
                  panelClass="custom-select-panel"
                >
                  <mat-option
                    *ngFor="let language of availableLanguages | keyvalue : sortByValue"
                    [value]="language.key"
                  >
                      {{ language.value }}
                  </mat-option>
                </mat-select>
                <mat-error
                  role="none"
                  *ngIf="(registrationUserNameForm.get('preferredLanguage').touched ||
                registrationUserNameForm.get('preferredLanguage').dirty) && registrationUserNameForm.get('preferredLanguage').errors?.['required'] &&
                !registrationUserNameForm.get('preferredLanguage').valid"
                >
                  <span
                    >{{'This is a required field, and a value from the list must be selected' | translation}}</span
                  >
                </mat-error>
              </mat-form-field>                     
            </li>
             <mat-divider class="mat-divider"></mat-divider>

                <div class="tw-w-full tw-flex tw-justify-end app-mt2">
                  <app-button
                    type="button"
                    emphasis="Low"
                    mat-raised-button
                    (click)="onCancel()"
                    class="app-pr2"
                  >
                  {{'Cancel' | translation : translationRequest }}
                    
                  </app-button>

                  <app-button
                    type="submit"
                    [disabled]="!registrationUserNameForm.valid"
                    emphasis="High"
                    (click)="onSubmit()"
                    mat-raised-button
                    aria-label="Submit"
                  >
                  {{'Submit' | translation : translationRequest }}
                    
                  </app-button>
                </div>
              </ul>
              <p class="app-mt2">
                <app-toast
                  *ngIf="personalInfoErrorMessage != ''"
                  [message]="personalInfoErrorMessage"
                  [type]="toastEnumOptions.Error"
                ></app-toast>
              </p>
            </form>
          </div>
        </div>
      </div>

      <!-- form end -->
      <!-- Choose User name END -->
    </div>
    <div *ngIf="registrationSuccess" class="registration-container app-mt3">
      <p class="registrationContent" class="app-mt2">
        <app-toast
          [message]="registrationSuccess"
          [type]="toastEnumOptions.Success"
        ></app-toast>
      </p>
    </div>
    </div>
  `,
  styles: [
    `
      .registration-toast {
        background-color: var(--dark-blue);
        color: white;
        max-width: 600px;
      }

      .registration-container {
        width: 80%;
        max-width: 630px;
        margin: 30px;
      }

      .registration-container * {
        box-sizing: border-box;
      }
    `,
  ],
  animations: [],
})
export class RegistrationComponent implements OnInit {
  toastPopupOptions = ToastPopUpComponents;
  public loading = false;
  public translationsReady = false;
  animationsDisabled = true;
  haveClaimNumberModel: string;
  onHaveClaimNumberStep = false;
  onStartRegistration = false;
  onSelectUsername = false;
  isVanityRegistration = false;
  showEmployeeId = false;
  showSSN = true;
  showDOB = true;
  showZipCode = true;
  showLastName = false;
  maxZipcodeLength: number = 5;
  isAlphanumericZipCode: boolean = false;
  personalInfoErrorMessage: string = '';
  registrationProcessErrorMessage: string = '';
  registrationSuccess: string = '';
  toastEnumOptions = ToastOptions;
  registrationRequest: RegistrationExport;
  currentRegistrationExport: RegistrationExport;
  maxDate = new Date();
  regClaimNumberForm: UntypedFormGroup;
  registrationForm: UntypedFormGroup;
  registrationUserNameForm: UntypedFormGroup;
  labelEmployeeID: string;
  labelZipCode: string = 'Home postal code';
  errorZipCode: string = 'Error : Home postal code is required.';
  requireClaimNumber: boolean = false;
  requireEmpId: boolean = false;
  hidePw: boolean = true;
  datePipe: DatePipe = new DatePipe('en-US');
  registrationMethod: string = '';
  isLiabilityClaim = false;
  zipCode6CharMessage: string;
  zipCode5CharMessage: string;
  rdYes: boolean = false;
  rdNo: boolean = false;
  datePickerOpen = false;
  datePickerAriaChanged = false;
  interval_login: any;
  availableLanguages = new Map<string, string>();
  ssoRegistrationInfo: SsoRegistrationRequest;
  title: string;
  showMultilanguage = false;
  dayNamesList: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  loginToken: string;
  redirectUrl: string;
  sourceUrl: string;
  @ViewChild(RegistrationSecurityquestionsComponent)
  regSecQuestions: RegistrationSecurityquestionsComponent;
  @ViewChild('dob', { static: false }) dobCalender: MatDatepicker<any>;
  translationRequest: TranslationRequest = new TranslationRequest(
    {
      language: sessionStorage.getItem('languagepreference'), // Default to English, you can make this dynamic
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'LoginApp',
      subGroup: 'LoginApp'
    }
  );

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private titleService: Title,
    private snackBar: MatSnackBar,
    private registrationService: UserRegistrationService,
    public dialog: MatDialog,
    private userService: UserService,
    public utility: UtilityService,
    public voe: VoeService,  
    public translationService: TranslationService,
    private adapter: DateAdapter<unknown>
  ) {}

  loadTranslations(): Promise<void> {
    if (!this.translationService.isLanguagePreferenceSet()) {
      // No translations needed for English
      this.translationsReady = true;
      return;
    }
    this.adapter.setLocale(sessionStorage.getItem('languagepreference'));

    // Start loading translations
    this.translationsReady = false;
    this.translationService.getTranslation(this.translationRequest);
    // Subscribe to translations observable to know when they're ready
     this.translationService.translations$.subscribe({
      next: (translations) => {
        if (translations && translations.size > 0) {
          this.translationsReady = true;
        }
      },
      error: (error) => {
        this.translationsReady = true;
      }
    }); 
  }
  
  /* Page Load Event: Display either Vanity URL Registration or Generic Registration based of Clientcode/Vanity  */
  async ngOnInit(): Promise<void> {
    let clientData = JSON.parse(sessionStorage.getItem('clientData'));
    this.translationRequest.contNum = clientData.contNum;
    await this.loadTranslations();
    this.showMultilanguage = this.translationService.isMultiLanagueFeatureEnabled();
    this.translationService.getTranslationForKey$('mySedgwick - Registration', this.translationRequest)
    .subscribe((translation: string) => {
      this.titleService.setTitle(translation);
    });

    this.ssoRegistrationInfo = this.userService.ssoRegistrationRequest;
    this.sourceUrl = this.userService.mySedgwickUrl;

    if (this.ssoRegistrationInfo?.DoSsoRegistration)
      this.setSsoRegistrationInfo(clientData, this.ssoRegistrationInfo);



    if (
      !this.utility.isNullOrEmpty(clientData.vanityPath) ||
      !this.utility.isNullOrEmpty(clientData.clientCode)
    ) {
      /* Vanity/Client specific */
      this.currentRegistrationExport = new RegistrationExport();
      this.registrationRequest = new RegistrationExport();
      this.registrationRequest.Screen = 'NewVanity';
      this.registrationRequest.clientCode = clientData.clientCode;
      this.registrationRequest.vanityPath =
        clientData.vanityPath == null ? '' : clientData.vanityPath;
      this.registrationRequest.SourceURL = this.sourceUrl;
      this.registrationService
        .ProcessRegistration(this.registrationRequest)
        .subscribe((dataForAPI) => {
          this.currentRegistrationExport = dataForAPI;
          this.registrationProcessErrorMessage = 'Success';

           this.labelEmployeeID = this.voe.getAliasedLabel(
            this.labelEmployeeID,
            dataForAPI.labelAliases.employeeIdSingular
          ); 

          //this.labelEmployeeID = this.translationService.getTranslationForKey$('Employee Id');
    

          if (dataForAPI.status.toString() === 'NotFound') {
            this.router.navigateByUrl('/technicaldifficulties');
            return;
          } else if (dataForAPI.status.toString() === 'DeadClient') {
            //Dead Client in Juris
            this.translationService.getTranslationForKey$('You do not have permission to access mySedgwick.', this.translationRequest).subscribe((translation) => {
              this.registrationProcessErrorMessage = translation;
            });
            this.requireClaimNumber = false;
            this.requireEmpId = false;
          } else if (dataForAPI.status.toString() === 'ClientNotSetupYet') {
            //mySedgwick is not setup for client
            this.translationService.getTranslationForKey$('You do not have permission to access mySedgwick.', this.translationRequest).subscribe((translation) => {
              this.registrationProcessErrorMessage = translation;
            });
                this.requireClaimNumber = false;
            this.requireEmpId = false;
          } else {
            this.registrationMethod = dataForAPI.method.toString();
            this.setRegistrationOptionForClient(
              this.registrationMethod,
              dataForAPI.registrationOptions.toString()
            );
          }
        });
      this.onHaveClaimNumberStep = false;
      this.onStartRegistration = true;
      this.onSelectUsername = false;
    } else {
      /* Generic URL with Claim #*/
      this.currentRegistrationExport = new RegistrationExport();
      this.onHaveClaimNumberStep = true;
      this.onStartRegistration = false;
      this.onSelectUsername = false;
      this.registrationProcessErrorMessage = 'Success';
      this.maxZipcodeLength = 6;
    }

    this.regClaimNumberForm = this.formBuilder.group({
      haveClaimNumber: ['', [Validators.required]],
      claimNumber: [''],
    });

    this.registrationForm = this.formBuilder.group({
      dateofBirth: ['', [Validators.required]],
      last4SSN: [
        '',
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
      employeeId: [
        '',
        [Validators.maxLength(256), Validators.pattern('^[0-9]*$')],
      ],
      zipCode: [
        '',
        [Validators.required, Validators.minLength(5), this.validateZipcode],
      ],
      claimNumberForReg: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      claimCity: ['', [Validators.required]],
      claimState: ['', [Validators.required]],
    });
    this.setValidators();

    this.registrationUserNameForm = this.formBuilder.group({
      userName: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern('(?=.*[a-zA-Z])[a-zA-Z0-9._@-]*'),
        ],
      ],
      passwordGroup: [],
      // firstName: ['', [
      //   Validators.required,
      //   Validators.minLength(2),
      //   Validators.maxLength(50),
      //   Validators.pattern('(?=.*[a-zA-Z])[a-zA-Z0-9-.,_@\' ]*')
      // ]],
      lastName: [
        '',
        [
          //Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
          Validators.pattern("(?=.*[a-zA-Z])[a-zA-Z0-9-.,_@' ]*"),
        ],
      ],
      personalEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
      mobileNumber: ['', []],
      preferredLanguage : [this.translationService.getDefaultLangauge(),[Validators.required]],
    });
    this.setValidators();

    this.setClass();
    this.getLangaugeList();
   
  }

  sortByValue = (a: { key: string, value: string }, b: { key: string, value: string }): number => {
    return a.value.localeCompare(b.value);
  }
   getLangaugeList(){
    if (this.translationService && this.translationService.isMultiLanagueFeatureEnabled) {
      let clientData = JSON.parse(sessionStorage.getItem('clientData'));
      this.translationService.getLanguages(clientData.contNum).subscribe({
        next: (languages: Record<string, string>) => {
          this.availableLanguages = new Map(Object.entries(languages));
        },
        error: (error) => {
          console.error('Error loading available languages:', error);
          // Set default empty object on error
          this.availableLanguages = new Map<string, string>();
        }
      });
    }
  }

  setClass() {
    return (date: any) => {
      if (date.getDate() == 1)
        this.monthChange({
          month: date.getMonth() + 1,
          year: date.getFullYear(),
        });
    };
  }

  setValidators() {
    {
      if (this.showEmployeeId == false && this.requireEmpId == false) {
        //This if condition need to be changed once we remove duplicate Employee ID in html.
        this.registrationForm.get('employeeId').clearValidators();
        this.registrationForm.get('employeeId').updateValueAndValidity();
      } else {
        this.registrationForm
          .get('employeeId')
          .setValidators(Validators.required);
        this.registrationForm.get('employeeId').updateValueAndValidity();
      }

      if (this.showZipCode == false) {
        this.registrationForm.get('zipCode').clearValidators();
      }

      if (this.showSSN == false) {
        this.registrationForm.get('last4SSN').clearValidators();
      }

      if (!this.requireClaimNumber) {
        this.registrationForm.get('claimNumberForReg').clearValidators();
      } else {
        this.registrationForm
          .get('claimNumberForReg')
          .setValidators(Validators.required);
      }

      if (this.isLiabilityClaim == true) {
        this.registrationForm
          .get('lastName')
          .setValidators(Validators.required);
        this.registrationForm
          .get('claimCity')
          .setValidators(Validators.required);
        this.registrationForm
          .get('claimState')
          .setValidators(Validators.required);
        if (this.showZipCode)
          this.registrationForm
            .get('zipCode')
            .setValidators(Validators.required);

        this.registrationForm.get('lastName').updateValueAndValidity();
        this.registrationForm.get('claimCity').updateValueAndValidity();
        this.registrationForm.get('claimState').updateValueAndValidity();

        this.registrationForm.get('dateofBirth').clearValidators();
        this.registrationForm.get('dateofBirth').updateValueAndValidity();

        if (this.registrationUserNameForm)
          this.registrationUserNameForm.get('personalEmail').clearValidators();
      } else {
        this.registrationForm.get('claimCity').clearValidators();
        this.registrationForm.get('claimState').clearValidators();

        if (this.registrationUserNameForm)
          this.registrationUserNameForm
            .get('personalEmail')
            .updateValueAndValidity();
      }

      if (this.registrationMethod != 'Claim') {
        this.registrationForm.get('lastName').clearValidators();
      } else {
        this.registrationForm
          .get('lastName')
          .setValidators(Validators.required);
      }

      this.registrationForm.get('employeeId').updateValueAndValidity();
      this.registrationForm.get('zipCode').updateValueAndValidity();
      this.registrationForm.get('last4SSN').updateValueAndValidity();
      this.registrationForm.get('claimNumberForReg').updateValueAndValidity();
    }
  }

  handleChange(selectedVal: string) {
    if (selectedVal == 'NO') {
      this.regClaimNumberForm.get('claimNumber').clearValidators();
      this.regClaimNumberForm.get('claimNumber').updateValueAndValidity();
      this.rdNo = true;
      this.rdYes = false;
    } else {
      this.regClaimNumberForm
        .get('claimNumber')
        .setValidators(Validators.required);
      this.regClaimNumberForm.get('claimNumber').updateValueAndValidity();
      this.rdYes = true;
      this.rdNo = false;
    }
  }

  setRegistrationOptionForClient(
    registrationMethod: string,
    registrationOption: string
  ) {
    if (this.ssoRegistrationInfo?.DoSsoRegistration) {
      if (registrationMethod == 'None') {
        registrationMethod = 'Hr';
        registrationOption = 'Default';
      }
    }

    switch (registrationMethod) {
      case 'Hr':
        this.showLastName = false;
        this.isLiabilityClaim = false;
        switch (registrationOption) {
          case 'Default': //0 DOB + Last 4 SSN + EmployeeID
            this.showZipCode = false;
            this.showEmployeeId = true;
            this.showSSN = true;
            this.showDOB = true;
            break;
          case 'Ssn4Zip': //1
            this.showZipCode = true;
            this.showEmployeeId = false;
            this.showSSN = true;
            this.showDOB = true;
            break;
          case 'EmpIdZip': //2
            this.showSSN = false;
            this.showEmployeeId = true;
            this.showDOB = true;
            this.showZipCode = true;
            this.maxZipcodeLength = 6;
            this.isAlphanumericZipCode = true;
            break;
          case 'EmpIdZip6': //3
            this.showSSN = false;
            this.showEmployeeId = true;
            this.showDOB = true;
            this.showZipCode = true;
            this.maxZipcodeLength = 6;
            this.isAlphanumericZipCode = true;
            //showClaimNumberInfo(false);
            break;
          case 'SsnHomeZip': //4
            this.showSSN = true;
            this.showEmployeeId = false;
            this.showDOB = true;
            this.showZipCode = true;
            break;
          case 'Ssn4EmpIdZip': //5
            this.showSSN = true;
            this.showEmployeeId = true;
            this.showDOB = true;
            this.showZipCode = true;
            break;
          /*case "PRClaim":
            break;
          case "GLClaim":
            break;
          case "AUClaim":
            break;*/
          /*case "LiabilityClaim":
            this.showSSN = false;
            this.showEmployeeId = false;
            this.showDOB = false;
            this.showZipCode = false;
            this.requireClaimNumber = true;
            this.isLiabilityClaim = true;
            break;*/
        }
        break;

      case 'Claim': //CLAIM Registration RegistrationMethod.Claim
        this.showLastName = true;
        this.requireClaimNumber = true;

        switch (registrationOption) {
          case 'LiabilityClaim':
            this.showSSN = false;
            this.showEmployeeId = false;
            this.showDOB = false;
            this.showZipCode = true;
            this.maxZipcodeLength = 5;
            this.isLiabilityClaim = true;
            this.labelZipCode = 'Postal Code';
            this.errorZipCode = 'Postal Code is required.';
            break;
          case 'LiabilityCityState':
            this.showSSN = false;
            this.showEmployeeId = false;
            this.showDOB = false;
            this.showZipCode = false;
            this.isLiabilityClaim = true;
            break;
        }
        break;
      default:
        break;
    }

    this.setValidators();
  }

  /* From Generic URL */
  moveToRegistration() {
    if (!this.regClaimNumberForm.invalid) {
      if (this.regClaimNumberForm.get('haveClaimNumber').value == 'YES') {
        sessionStorage.setItem(
          'claimnumber',
          JSON.stringify(this.regClaimNumberForm.value.claimNumber)
        );
        this.currentRegistrationExport.claimNumber =
          this.regClaimNumberForm.value.claimNumber;
        this.currentRegistrationExport.Screen = 'HaveClaimNum';
        this.registrationService
          .SearchForRegistrationClaim(this.currentRegistrationExport)
          .subscribe(
            (data) => {
              this.currentRegistrationExport = data;
              this.registrationForm.setValue({
                claimNumberForReg: this.regClaimNumberForm.value.claimNumber,
                dateofBirth: '',
                last4SSN: '',
                zipCode: '',
                employeeId: '',
                lastName: '',
                claimCity: '',
                claimState: '',
              });
              if (data.validClaimFound == true) {
                sessionStorage.setItem('user', JSON.stringify(data));
                this.onHaveClaimNumberStep = false;
                this.onStartRegistration = true;
                this.onSelectUsername = false;
                this.personalInfoErrorMessage = '';
                this.labelEmployeeID = this.voe.getAliasedLabel(
                  this.labelEmployeeID,
                  data.labelAliases.employeeIdSingular
                );
                this.setRegistrationOptionForClient(
                  data.method.toString(),
                  data.registrationOptions.toString()
                );
                const clientData = JSON.parse(
                  sessionStorage.getItem('clientData')
                );
                clientData.loggedinImage = data.loggedinImage;
              } else {
                this.handleRegistrationStatus(data.status.toString(), data);
                sessionStorage.setItem('user', JSON.stringify(data));
                this.onHaveClaimNumberStep = true;
                this.onStartRegistration = false;
                this.onSelectUsername = false;
              }
            },
            (error) => {
              this.handleErr(error);
            }
          );
      } else {
        this.currentRegistrationExport.Screen = 'New';
        this.registrationService
          .ProcessRegistration(this.currentRegistrationExport)
          .subscribe((dataForAPI) => {
            this.currentRegistrationExport.token = dataForAPI.token;
          });
        this.personalInfoErrorMessage = '';
        this.onHaveClaimNumberStep = false;
        this.onStartRegistration = true;
        this.onSelectUsername = false;
      }
    }
  }

  setSsoRegistrationInfo(clientData: any, ssoRequest: SsoRegistrationRequest) {
    clientData.clientCode = ssoRequest.ClientCode;
    this.loginToken = this.userService.redirectToken;
    this.redirectUrl = this.userService.mySedgwickUrl;
  }

  processSsoRegistration(request: RegistrationExport) {
    this.registrationService
      .RegisterSamlUser(request)
      .subscribe((registrationData) => {
        //If success insert logic for redirect to TFA?
        // Handle error statuses
        this.handleSsoRegistrationStatus(
          registrationData.registration.status.toString(),
          registrationData
        );
      });
  }

  /* Valid User found - Display Username screen */
  moveToUserNameSelection() {
    if (!this.registrationForm.invalid) {
      this.getRegistrationInformation();
      this.personalInfoErrorMessage = '';
      this.currentRegistrationExport.Screen = 'Registration';
      this.currentRegistrationExport.claimNumber =
        this.registrationForm.value.claimNumberForReg.trim();
      this.currentRegistrationExport.labelAliases = null;
      if (this.ssoRegistrationInfo?.DoSsoRegistration)
        this.currentRegistrationExport.registrationSource =
          RegistrationSource.ViaoneView;

      this.registrationService
        .ProcessRegistration(this.currentRegistrationExport)
        .subscribe((dataForAPI) => {
          if (dataForAPI.labelAliases != null)
             this.labelEmployeeID = this.voe.getAliasedLabel(
              this.labelEmployeeID,
              dataForAPI.labelAliases.employeeIdSingular
            ); 
          this.registrationUserNameForm.setValue({
            lastName: this.registrationForm.value.lastName,
            //firstName: "",
            userName: '',
            passwordGroup: '',
            personalEmail: '',
            mobileNumber: '',
            preferredLanguage:this.translationService.getDefaultLangauge()
          });

          if (
            this.ssoRegistrationInfo?.DoSsoRegistration &&
            dataForAPI.status.toString() == 'Valid'
          ) {
            this.currentRegistrationExport = dataForAPI;
            this.currentRegistrationExport.username =
              this.ssoRegistrationInfo?.Username;
            this.currentRegistrationExport.sessionId =
              this.ssoRegistrationInfo.SessionId;
            this.processSsoRegistration(this.currentRegistrationExport);
          } else {
            this.currentRegistrationExport.token = dataForAPI.token;
            this.handleRegistrationStatus(
              dataForAPI.status.toString(),
              dataForAPI
            );
            this.setValidators();
          }
        });
    }
  }

  /* UserName/Password accepted - Register User*/
  onSubmit() {
    if (!this.registrationUserNameForm.invalid) {
      this.doBuildRegistrationModel();
      this.currentRegistrationExport.Screen = 'CreateUser';
      this.currentRegistrationExport.labelAliases = null;
      this.registrationService
        .Register(this.currentRegistrationExport)
        .subscribe((dataForAPI) => {
          switch (dataForAPI.status.toString()) {
            case 'Success':
              this.personalInfoErrorMessage = '';
              this.onSelectUsername = false;
              this.translationService.getTranslationForKey$(`Your registration was successful. `, this.translationRequest).subscribe((translation1) => {
                this.translationService.getTranslationForKey$(`You will receive a confirmation email at the address you provided during the registration process. You can now login to`, this.translationRequest).subscribe((translation2) => {
                  this.registrationSuccess = translation1 + ' <br aria-hidden=\'true\'/> ' + translation2 + ` <a href='/' class='spanLink'>mySedgwick</a>.`;
                });
              });
              break;
            default:
              this.handleRegistrationFailStatus(dataForAPI.status.toString());
              break;
          }
        });
    } else {
      alert('failed');
    }
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }

  getRegistrationInformation() {
    this.currentRegistrationExport.claimCity =
      this.registrationForm.value.claimCity.trim();
    this.currentRegistrationExport.claimState =
      this.registrationForm.value.claimState.trim();
    this.currentRegistrationExport.lastName =
      this.registrationForm.value.lastName.trim();
    this.currentRegistrationExport.zipCode =
      this.registrationForm.value.zipCode.trim();
    this.currentRegistrationExport.employeeId =
      this.registrationForm.value.employeeId.trim();
    this.currentRegistrationExport.ssn =
      this.registrationForm.value.last4SSN.trim();

    const dob = this.utility.isNullOrEmpty(
      this.registrationForm.value.dateofBirth
    )
      ? this.registrationForm.value.dateofBirth
      : this.datePipe.transform(
          this.registrationForm.value.dateofBirth.toDateString(),
          'M/d/yyyy'
        );
    this.currentRegistrationExport.dateOfBirth = dob;
    //this.currentRegistrationExport.email = this.registrationForm.value.email;

    if (
      this.currentRegistrationExport.registrationOptions === 6 ||
      this.currentRegistrationExport.registrationOptions === 7 ||
      /*
            [KP] As per old code we can additional registration options but
            I cannot see those in Old enum so, I am commenting following
            conditions till figure out remaining requirements.

      this.currentRegistrationExport.registrationOptions === 19 ||
      this.currentRegistrationExport.registrationOptions === 20 ||*/
      this.currentRegistrationExport.registrationOptions === 8
    ) {
      this.currentRegistrationExport.claimNumber =
        this.registrationForm.value.claimNumberForReg.trim();
      this.currentRegistrationExport.claimCity =
        this.registrationForm.value.claimCity.trim();
      this.currentRegistrationExport.claimState =
        this.registrationForm.value.claimState.trim();
      this.currentRegistrationExport.zipCode =
        this.registrationForm.value.zipCode.trim();
    }

    if (
      !this.utility.isNullOrEmpty(this.currentRegistrationExport.clientCode)
    ) {
      if (!this.utility.isNullOrEmpty(this.registrationForm.value.employeeId)) {
        this.currentRegistrationExport.employeeId =
          this.registrationForm.value.employeeId.trim();
      }
      if (this.currentRegistrationExport.method.toString() === 'Claim') {
        this.currentRegistrationExport.claimNumber =
          this.registrationForm.value.claimNumberForReg.trim();
        this.currentRegistrationExport.zipCode =
          this.registrationForm.value.zipCode.trim();
        this.currentRegistrationExport.lastName =
          this.registrationForm.value.lastName.trim();
      }
      if (
        this.currentRegistrationExport.registrationOptions === 6
        /*
            [KP] As per old code we can additional registration options but
            I cannot see those in Old enum so, I am commenting following conditions
            till figure out remaining requirements.

        || this.currentRegistrationExport.registrationOptions === 9 ||
        this.currentRegistrationExport.registrationOptions === 19 ||
        this.currentRegistrationExport.registrationOptions === 20*/
      ) {
        this.currentRegistrationExport.claimNumber =
          this.registrationForm.value.claimNumberForReg.trim();
        this.currentRegistrationExport.claimCity =
          this.registrationForm.value.claimCity.trim();
        this.currentRegistrationExport.claimState =
          this.registrationForm.value.claimState.trim();
        this.currentRegistrationExport.zipCode =
          this.registrationForm.value.zipCode.trim();
      }
    }
    /*       this.currentRegistrationExport.sourceSystem = "";
          this.currentRegistrationExport.subSystem = ""; */
  }

  handleSsoRegistrationStatus(status: string, dataForApi: SsoRegistration) {
    switch (status) {
      case 'Success':
        this.personalInfoErrorMessage = '';
        this.userService
          .createSsoTwoFactorRequest(
            new SsoRegistration({ loginResponse: dataForApi.loginResponse })
          )
          .subscribe((result) => {
            if (result) {
              this.navigateToSsoTfa(dataForApi.loginResponse);
            }
          });
        break;
      default:
        this.translationService.getTranslationForKey$(`We are unable to proceed with your registration using the information you provided. Please
              confirm your entry and try again. For additional assistance,`, this.translationRequest).subscribe((translation1) => {
          this.translationService.getTranslationForKey$(`Contact Technical Support`, this.translationRequest).subscribe((translation2) => {
            this.translationService.getTranslationForKey$(` or your HR department for more information.`, this.translationRequest).subscribe((translation3) => {
              this.personalInfoErrorMessage = translation1 +
                `<a tabindex='0' class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${translation2}</a>` +
                translation3;
            });
          });
        });
    }
  }

  navigateToSsoTfa(results: LoginResponse): void {
    this.userService.emailAddress = results.emailAddress;
    this.userService.phoneNumber = results.phone;
    this.userService.username = results.username;
    this.userService.ssoRegistration = true;
    this.userService.sessionid = results.sessionId;
    this.userService.redirectToken = this.loginToken;
    this.userService.mySedgwickUrl = this.redirectUrl;
    this.router.navigate(['multiFactorAuthentication']);
  }

  handleRegistrationStatus(status: string, dataForAPI: RegistrationExport) {
    // Using async approach with observables for translations
    this.translationService.getTranslationForKey$(`We are unable to proceed with your registration using the information you provided.`, this.translationRequest).subscribe((statusMessage0) => {
      this.translationService.getTranslationForKey$(`Please `, this.translationRequest).subscribe((pleaseText) => {
        this.translationService.getTranslationForKey$(` Contact support`, this.translationRequest).subscribe((statusMessage2) => {
          this.translationService.getTranslationForKey$(` or your HR department for more information.`, this.translationRequest).subscribe((statusMessage3) => {
            this.translationService.getTranslationForKey$(`We are unable to proceed with your registration using the information you provided, please provide the claim number. If you do not have a claim number please`, this.translationRequest).subscribe((statusMessage4) => {
              this.translationService.getTranslationForKey$(`Please confirm your entry and try again. For additional assistance,`, this.translationRequest).subscribe((statusMessage5) => {
                this.translationService.getTranslationForKey$(` or your HR department for more assistance.`, this.translationRequest).subscribe((statusMessage6) => {
                  this.translationService.getTranslationForKey$(`Redirects to contact support`, this.translationRequest).subscribe((arialabelText) => {
                    const statusMessage1 = statusMessage0 + ' ' + pleaseText;
                    this.processRegistrationStatus(status, dataForAPI, statusMessage0, statusMessage1, statusMessage2, statusMessage3, statusMessage4, statusMessage5, statusMessage6, arialabelText);
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  processRegistrationStatus(status: string, dataForAPI: RegistrationExport, statusMessage0: string, statusMessage1: string, statusMessage2: string, statusMessage3: string, statusMessage4: string, statusMessage5: string, statusMessage6: string, arialabelText: string) {
    switch (status) {
      case 'Valid':
        /* If its Valid - we need to reset currentRegistrationExport*/
        this.currentRegistrationExport = dataForAPI;
        this.onHaveClaimNumberStep = false;
        this.onStartRegistration = false;
        this.onSelectUsername = true;
        this.personalInfoErrorMessage = '';
        break;
      case 'UserAlreadyExists':
        this.translationService.getTranslationForKey$(`user name/password redirects to forgot password page`, this.translationRequest).subscribe((userAriaLabel) => {
          this.translationService.getTranslationForKey$(`You already have an existing account for mySedgwick. `, this.translationRequest).subscribe((existingAccountText) => {
            this.translationService.getTranslationForKey$(`Please use your `, this.translationRequest).subscribe((pleaseUseText) => {
              this.translationService.getTranslationForKey$('user name', this.translationRequest).subscribe((userNameText) => {
                this.translationService.getTranslationForKey$('password', this.translationRequest).subscribe((passwordText) => {
                  this.translationService.getTranslationForKey$(` to login.`, this.translationRequest).subscribe((toLoginText) => {
                    this.personalInfoErrorMessage = existingAccountText + ' <br aria-hidden=\'true\'/>' + 
                    pleaseUseText + 
                    ` <a tabindex=\'0\' class=\'spanLink\' aria-label=\'${userAriaLabel}\' role=\'link\'  data-function=\'${this.toastPopupOptions.forgotPassword}\' routerLink=\'/forgotPassword\'>` 
                    + userNameText + '/' + passwordText + '</a> '
                    + toLoginText;
                  });
                });
              });
            });
          });
        });
        break;

      case 'MultipleContract':
        this.currentRegistrationExport.status = dataForAPI.status;
        this.currentRegistrationExport.statusAsString =
          dataForAPI.statusAsString;
        if (!this.utility.isNullOrEmpty(dataForAPI.claimNumber))
          this.personalInfoErrorMessage = statusMessage1 + 
              `<a tabindex='0' role='link' aria-label='${arialabelText}' class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;
        else {
          if (dataForAPI.contractNumber > 0)
            this.personalInfoErrorMessage = statusMessage1 +
              `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;
          else {
            this.requireClaimNumber = true;
            this.personalInfoErrorMessage = statusMessage4 +
              `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;
          }
        }

        break;
      case 'NotFound':
        if (!this.utility.isNullOrEmpty(dataForAPI.claimNumber))
          this.personalInfoErrorMessage = statusMessage1 +
              `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;
        else
          this.personalInfoErrorMessage = statusMessage4 +
            `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;
        break;

      case 'Denied':
        this.personalInfoErrorMessage = statusMessage0 + ' <br aria-hidden=\'true\'/> ' + statusMessage5 +
        `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3 + statusMessage6;
        statusMessage6;
        //personalInfoErrorMessage(model().GenericEmployeeLandingMessage.Text);
        break;

      case 'HrClientNoMatch':
      case 'HrClientNoMatchTerminated':
        this.personalInfoErrorMessage = statusMessage0 + ' <br aria-hidden=\'true\'/> ' + statusMessage5 +
        `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3 + statusMessage6;
        break;

      case 'DeadClient':
      case 'ClientNotSetupYet':
      case 'ClientNotLive':
        this.translationService.getTranslationForKey$(`You do not have permission to access mySedgwick.`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
      case 'EmailInValid':
        this.translationService.getTranslationForKey$(`We are unable to complete your registration. Please contact your examiner to verify your information or to provide your email address and phone number.`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;

        
      case 'NoRegistration': //gets hit when no data found with IO claims for Liability lines
        this.personalInfoErrorMessage = statusMessage1 +
        `<a tabindex='0' role='link' aria-label='${arialabelText}' class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;

        break;
      case 'ProvideEmployeeId':
        this.requireEmpId = true;
        this.translationService.getTranslationForKey$(`Additional information required for registration`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
      case 'ProvideClaimNumber':
        this.requireClaimNumber = true;
        this.translationService.getTranslationForKey$(`Additional information required for registration`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
      case 'OfficeRestricted':
        this.translationService.getTranslationForKey$(`The claim number you have entered is restricted and we are not able proceed with the registration process using this claim number. For additional details on the restricted claim number you entered, please contact your HR department.`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;

      case 'ClaimClosed':
        this.translationService.getTranslationForKey$(`Additional information required for registration`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
      case 'PhoneInValid':
      case 'NotIndividual':
      case 'LOBNotSupportedByClient':
      case 'ContactInValid':
        this.translationService.getTranslationForKey$(`We are unable to complete your registration. Please contact your examiner to verify your information or to provide your email address and phone number.`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
      case 'ClaimNotFound':
      case 'MultipleClaims':
        this.translationService.getTranslationForKey$(`You may retry or`, this.translationRequest).subscribe((retryText) => {
          this.personalInfoErrorMessage = statusMessage0 + ' ' + retryText +
                `<a tabindex='0' role='link' aria-label='${arialabelText}'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${statusMessage2}</a>` + statusMessage3;
        });
        break;
      default:
        this.translationService.getTranslationForKey$(`Error`, this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
    }
  }

  validateZipcode(fc: UntypedFormControl): Validators {
    if (fc.value && fc.value.length > 5)
      return fc.value.match('^[A-Za-z]\\d[A-Za-z][ -]?\\d[A-Za-z]\\d$')
        ? null
        : { inValidZopcodeCanada: true };
    else if (fc.value && fc.value.length == 5)
      return fc.value.match('^[0-9]{5}(-[0-9]{4})?$')
        ? null
        : { inValidZopcodeUS: true };
  }

  showHideAnswers(showHideAnswers: boolean) {
    this.hidePw = showHideAnswers;
  }

  doBuildRegistrationModel() {
    this.currentRegistrationExport.username =
      this.registrationUserNameForm.value.userName.trim();
    this.currentRegistrationExport.password =
      this.registrationUserNameForm?.get(
        'passwordGroup'
      ).value.controls.newPassword.value;
    // this.currentRegistrationExport.securityQuestion = this.regSecQuestions.regSecurityQuesionsForm.value.securityQuestion1;
    // this.currentRegistrationExport.securityQuestion2 = this.regSecQuestions.regSecurityQuesionsForm.value.securityQuestion2;
    // this.currentRegistrationExport.securityQuestion3 = this.regSecQuestions.regSecurityQuesionsForm.value.securityQuestion3;
    // this.currentRegistrationExport.securityQuestion4 = this.regSecQuestions.regSecurityQuesionsForm.value.securityQuestion4;
    // this.currentRegistrationExport.securityQuestion5 = this.regSecQuestions.regSecurityQuesionsForm.value.securityQuestion5;
    // this.currentRegistrationExport.securityAnswer = this.regSecQuestions.regSecurityQuesionsForm.value.securityAnswer1.toLowerCase().trim();
    // this.currentRegistrationExport.securityAnswer2 = this.regSecQuestions.regSecurityQuesionsForm.value.securityAnswer2.toLowerCase().trim();
    // this.currentRegistrationExport.securityAnswer3 = this.regSecQuestions.regSecurityQuesionsForm.value.securityAnswer3.toLowerCase().trim();
    // this.currentRegistrationExport.securityAnswer4 = this.regSecQuestions.regSecurityQuesionsForm.value.securityAnswer4.toLowerCase().trim();
    // this.currentRegistrationExport.securityAnswer5 = this.regSecQuestions.regSecurityQuesionsForm.value.securityAnswer5.toLowerCase().trim();

    // this.currentRegistrationExport.firstName = this.registrationUserNameForm.value.firstName.trim();
    // this.currentRegistrationExport.lastName = this.registrationUserNameForm.value.lastName.trim();

    this.currentRegistrationExport.email =
      this.registrationUserNameForm.value.personalEmail.trim();
    this.currentRegistrationExport.twoFactorPhone =
      this.registrationUserNameForm.value.mobileNumber.phoneNumber ?? ''; //this.regSecQuestions.regSecurityQuesionsForm.value.mobileNumber.phoneNumber ?? "";
       this.currentRegistrationExport.preferredLangauge = 
      this.registrationUserNameForm.value.preferredLanguage.trim();
  }

  handleRegistrationFailStatus(status: string): void {
    switch (status) {
      case 'FailedToRegister':
        this.translationService.getTranslationForKey$(`An unknown error occurred please click`, this.translationRequest).subscribe((errorText) => {
          this.translationService.getTranslationForKey$(`here`, this.translationRequest).subscribe((hereText) => {
            this.translationService.getTranslationForKey$(` to contact support.`, this.translationRequest).subscribe((contactText) => {
              this.personalInfoErrorMessage = errorText +
              `<a tabindex='0' role='link' aria-label='Redirects to Contact support'  class='spanLink' data-function=${this.toastPopupOptions.openSupportDialog}> ${hereText}  </a>` +
              contactText;
            });
          });
        });
        break;
      case 'UserAlreadyExists':
        this.translationService.getTranslationForKey$('This user name is already taken please try another one.', this.translationRequest).subscribe((translation) => {
          this.personalInfoErrorMessage = translation;
        });
        break;
    }
  }

  //WCAG accessibility
  toggleDatepicker(): void {
    setTimeout(() => {
      //$("div.cdk-visually-hidden").removeAttr("tabindex");
      var captionElement = document.createElement('caption');
      captionElement.style.setProperty('display', 'block');
      captionElement.style.setProperty('font-size', '0px');
      captionElement.style.setProperty('height', '0px');
      captionElement.tabIndex = -1;
      //document.getElementsByClassName("cdk-focus-trap-anchor")[0].setAttribute("tabindex","-1");
      // captiionElement.setAttribute("aria-label","Table to display dates");
      captionElement.appendChild(
        document.createTextNode('Table to display dates')
      );

      var dateTable = document.getElementsByClassName('mat-calendar-table')[0];
      dateTable.prepend(captionElement);
      dateTable.setAttribute('role', 'grid');

      var dateModal = document.getElementsByClassName('mat-calendar')[0];
      dateModal.setAttribute('aria-label', 'Datepicker Modal');
      //dateModal.setAttribute("role", "");
      // if (document.getElementsByClassName("mat-button")) {
      //   const firstElDiv: HTMLDivElement = document.getElementsByClassName("mat-button")[0] as HTMLDivElement;
      //   firstElDiv.focus();
      // }

      var datepickerModelDiv = document.getElementsByClassName(
        'mat-datepicker-popup'
      );
      if (
        datepickerModelDiv != undefined &&
        datepickerModelDiv != null &&
        datepickerModelDiv.length > 0
      ) {
        for (var i = 0; i < datepickerModelDiv.length; i++) {
          if (datepickerModelDiv[i].hasAttribute('aria-label') == false) {
            datepickerModelDiv[i].setAttribute(
              'aria-label',
              'date picker modal'
            );
            datepickerModelDiv[i].setAttribute('tabindex', '0');
          }
        }
      }

      this.matDatePickerHeaderModification();
    }, 200);
  }

  monthChange(seldate): void {
    setTimeout(() => {
      this.matDatePickerHeaderModification();
    }, 1000);
  }

  matDatePickerDateAriaLabel(): void {
    var datePickerInnerRow = $('.mat-calendar-table tbody>tr>td');

    if (
      datePickerInnerRow != undefined &&
      datePickerInnerRow != null &&
      datePickerInnerRow.length > 0
    ) {
      for (var tdIndex = 0; tdIndex < datePickerInnerRow.length; tdIndex++) {
        var ariaLableOfTD: string = $(datePickerInnerRow[tdIndex]).attr(
          'aria-label'
        );
        var dayIndexOfTD = $(datePickerInnerRow[tdIndex]).attr('data-mat-col');
        if (
          ariaLableOfTD != undefined &&
          ariaLableOfTD != null &&
          ariaLableOfTD != ''
        ) {
          var existingDayName = this.dayNamesList.some((days) =>
            ariaLableOfTD.includes(days)
          );

          if (existingDayName == false) {
            var focusDate = new Date(ariaLableOfTD);
            var newAriaLabel =
              this.dayNamesList[Number(focusDate.getDay())] +
              ' ' +
              ariaLableOfTD;
            $(datePickerInnerRow[tdIndex]).attr('aria-label', newAriaLabel);
          }
        }
      }
    }
  }

  matDatePickerHeaderModification(): void {
    /*var datePickerHeaderRow = $(".mat-calendar-table .mat-calendar-table-header>tr");

    if(datePickerHeaderRow != undefined && datePickerHeaderRow != null && datePickerHeaderRow.length > 1)
    {
       $(datePickerHeaderRow[1]).remove();
    }*/

    var allTableHeader = $(
      '.mat-calendar-table .mat-calendar-table-header>tr>th'
    );

    if (
      allTableHeader != undefined &&
      allTableHeader != null &&
      allTableHeader.length > 0
    ) {
      for (var j = 0; j < allTableHeader.length; j++) {
        $(allTableHeader[j]).removeAttr('aria-label');

        $(allTableHeader[j]).text('');
        var spanDisplay = document.createElement('span');
        var spanHidden = document.createElement('span');
        document
          .getElementsByClassName('cdk-visually-hidden')[0]
          .removeAttribute('tabindex');
        spanDisplay.setAttribute('aria-hidden', 'true');
        spanHidden.setAttribute(
          'style',
          'height: 1px;width: 1px;position: absolute;overflow: hidden; top: -10px;'
        );
        var dayName: string = '';
        var dayNameAlias: string = '';
        switch (j) {
          case 0:
            dayName = 'Sunday';
            dayNameAlias = 'S';
            break;
          case 1:
            dayName = 'Monday';
            dayNameAlias = 'M';
            break;
          case 2:
            dayName = 'Tuesday';
            dayNameAlias = 'T';
            break;
          case 3:
            dayName = 'Wednesday';
            dayNameAlias = 'W';
            break;
          case 4:
            dayName = 'Thursday';
            dayNameAlias = 'T';
            break;
          case 5:
            dayName = 'Friday';
            dayNameAlias = 'F';
            break;
          case 6:
            dayName = 'Saturday';
            dayNameAlias = 'S';
            break;
        }

        if (dayName.length > 2) {
          spanDisplay.setAttribute('title', dayName);
          //spanDisplay.setAttribute("aria-label",dayName);
          spanDisplay.innerText = dayNameAlias;
          //spanHidden.setAttribute("title",dayName);
          //spanHidden.setAttribute("aria-label",dayName);
          //spanHidden.setAttribute("title",dayName);
          //spanHidden.setAttribute("aria-label",dayName);
          spanHidden.innerText = dayName;
          spanHidden.removeAttribute('aria-label');
          $(allTableHeader[j]).append(spanDisplay);
          $(allTableHeader[j]).append(spanHidden);
        }
      }
    }
    try {
      this.matDatePickerDateAriaLabel();
    } catch (e) {}
  }

  changeMatToggleButtonAria(): void {
    const matTogglerChild = document.querySelector(
      'mat-datepicker-toggle'
    )?.firstElementChild;
    if (matTogglerChild) {
      matTogglerChild?.setAttribute('aria-haspopup', 'false');
      this.datePickerAriaChanged == true;
    }
  }

  ngAfterViewInit(): void {
    this.interval_login = setInterval(() => {
      if (this.datePickerAriaChanged == false) {
        this.changeMatToggleButtonAria();
      }
    }, 500);
  }

  ngOnDestroy() {
    clearInterval(this.interval_login);
  }

  handleErr = (errMsg) => {
    if (errMsg === 'invalid') {
      this.openSnackBar('Unable to locate claimnumber');
    }
  };

  //Open snace bar
  openSnackBar(message: string, action = 'Close') {
    this.snackBar.open(message, action, {
      duration: 4000,
    });
  }
}
